import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import config from "../config";

const { api } = config;

// default
axios.defaults.baseURL = api.API_URL;
// content type - sẽ được set trong interceptor
// axios.defaults.headers.post["Content-Type"] = "application/json";

// Đọc token từ localStorage khi module load
const authUser: any = localStorage.getItem("authUser")
const initToken = authUser ? (JSON.parse(authUser).token || JSON.parse(authUser).access_token) : null;
if (initToken)
  axios.defaults.headers.common["Authorization"] = "Bearer " + initToken;

// Request interceptor: Gắn token mới nhất từ localStorage trước mỗi request
axios.interceptors.request.use(
  (config) => {
    const stored = localStorage.getItem("authUser");
    if (stored) {
      const user = JSON.parse(stored);
      const latestToken = user.token || user.access_token;
      if (latestToken) {
        config.headers["Authorization"] = "Bearer " + latestToken;
      }
    }
    
    // Set Content-Type cho request không phải FormData
    if (config.data instanceof FormData) {
      // Để axios tự động set Content-Type với boundary cho FormData
      // Không set Content-Type manually
    } else {
      // Set Content-Type mặc định cho JSON
      if (!config.headers["Content-Type"]) {
        config.headers["Content-Type"] = "application/json";
      }
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: Handle errors và đảm bảo luôn trả về serializable error
axios.interceptors.response.use(
   response => {
      return response.data;
    },
    error => {
      // Tạo serializable error object
      const serializedError: any = {
        message: error.message || 'An error occurred',
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
      };
      
      // Nếu có response data với message, ưu tiên sử dụng
      if (error.response?.data?.message) {
        serializedError.message = error.response.data.message;
      }
      
      return Promise.reject(serializedError);
    },
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token : string) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from the given URL
   */
  get = (url: string, params?: any): Promise<AxiosResponse> => {
    let response: Promise<AxiosResponse>;

    let paramKeys: string[] = [];

    if (params) {
      Object.keys(params).map(key => {
        paramKeys.push(key + '=' + params[key]);
        return paramKeys;
      });

      const queryString = paramKeys && paramKeys.length ? paramKeys.join('&') : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };

  download = (url: string): Promise<AxiosResponse> => {
    return axios.get(url, { responseType: "blob" });
  };

  /**
   * Posts the given data to the URL
   */
  create = (url: string, data: any): Promise<AxiosResponse> => {
    return axios.post(url, data);
  };

  /**
   * Updates data
   */
  update = (url: string, data: any): Promise<AxiosResponse> => {
    return axios.patch(url, data);
  };

  put = (url: string, data: any): Promise<AxiosResponse> => {
    return axios.put(url, data);
  };

  /**
   * Deletes data
   */
  delete = (url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return axios.delete(url, { ...config });
  };
}

/**
 * Lấy thông tin user đã đăng nhập từ localStorage
 * @returns User object hoặc null nếu chưa đăng nhập
 */
const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
